<button *ngIf="activeNetworking.partOfCollection" routerLink=".." class="fullsize-button">
    {{ collection.backButtonText }} 
  </button>
<div *ngIf="html" class="iframe-wrapper" [innerHtml]="url | safeHTML"></div>
<iframe
  allowusermedia
  allowfullscreen
  *ngIf="!html"
  [src]="url | safe"
  allow="camera *; microphone *;display-capture *;"
  sandbox="allow-top-navigation allow-scripts allow-forms allow-same-origin allow-popups allow-downloads"
></iframe>
